/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  var register_dob = document.querySelector('#register_dob-block input.date_picker'),
    register_dob_main_tag = document.querySelector('#register_dob-block #register_dob-block-tag');
  if(register_dob && register_dob_main_tag){
    register_dob.addEventListener('change', (event) => {
      if(register_dob.value){
        register_dob_main_tag.value = 'Dob: '+register_dob.value;
      }else{
        register_dob_main_tag.value = '';
      }
    });
  }


  var newsletter_dob = document.querySelector('#newsletter_dob-block input.date_picker'),
    newsletter_dob_main_tag = document.querySelector('#newsletter--dob-tag');
  
  var newsletter_gender_checkbox = document.querySelectorAll('#newsletter_gender-block input[type=checkbox]'),
    newsletter_gender_main_tag = document.querySelector('#newsletter--gender-tag');
  
  var newsletter_form_main_tag = document.querySelector('#newsletter_main-tag');

  if(newsletter_dob && newsletter_dob_main_tag && newsletter_gender_checkbox && newsletter_gender_main_tag && newsletter_form_main_tag){
    function newsletter_main_tag_val() {
      var dob = newsletter_dob_main_tag.value ? ', ' + newsletter_dob_main_tag.value : '';
      var main_val = newsletter_gender_main_tag.value + dob;
      newsletter_form_main_tag.value = main_val;
    }
  
     newsletter_gender_checkbox.forEach(checkbox => {
      checkbox.addEventListener('change', () => {
        var checkbox_value = [];
        newsletter_gender_checkbox.forEach(get_checkbox => {
          if(get_checkbox.checked){
            checkbox_value.push(get_checkbox.value);
          }
        });
        newsletter_gender_main_tag.value = checkbox_value.join(', ');
        newsletter_main_tag_val();
      });
    });
  
     newsletter_dob.addEventListener('change', (event) => {
       if(newsletter_dob.value){
          newsletter_dob_main_tag.value = 'Dob: '+newsletter_dob.value;
       }else{
         newsletter_dob_main_tag.value = '';
       }
       newsletter_main_tag_val();
    });
  }
  



  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.

  $( ".date_picker" ).datepicker({
    dateFormat: 'yy-mm-dd',
    maxDate: 0,
    minDate: new Date(1930, 1 - 1, 1),
    yearRange: '1930:2030',
    changeMonth: true, 
    changeYear: true,
    onSelect: function() {
      if(newsletter_dob){
        newsletter_dob.dispatchEvent(new Event('change', { bubbles: true }));
      }
      if(register_dob){
        register_dob.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  });
  
})();
